import React from 'react';

//Bootstrap
import { Container, Row, Col, Carousel } from 'react-bootstrap';

import TitleLightBold from '../TitleLightBold/TitleLightBold';

const CustomCarousel = (props) => {
    return (
        <Container fluid className="custom-bg-black">
            <div className="pt-5 text-white">
                <TitleLightBold textLight="Mirá algunas " textBold="fotos" titleType="h1" initSection={true} />
            </div>
            <Row className="p-5 justify-content-center text-align-center">
                <Col lg="7" xl="5" className="mb-mb-0 mb-5">
                    <Carousel controls={true} interval={2000}>
                        {props.images.map(i => <Carousel.Item key={i.id}>
                            <img src={i.src} alt={i.title} className="img-fluid" />
                        </Carousel.Item>)}
                    </Carousel>
                </Col>
            </Row>
        </Container>
    );
};

export default CustomCarousel;